module.exports = __webpack_public_path__ + "img/portrait.6d65f396.png";